export const ru = {
    'rejected-on-moderation': 'Не прошла модерацию'
};
